<template>
  <div class="diagram-container" :style="forceHeight">
    <svg xmlns="http://www.w3.org/2000/svg" :height="svgHeight" width="100%">
      <defs>
        <linearGradient x1="0" y1="0" x2="6.123233995736766e-17" y2="1" id="x-auto-147">
          <stop offset="0%" stop-color="#FFFFFF" stop-opacity="1"></stop>
          <stop offset="60%" stop-color="#C2E2F9" stop-opacity="1"></stop>
          <stop offset="100%" stop-color="#A5D6EE" stop-opacity="1"></stop>
        </linearGradient>
        <image id="userNode" href="@/assets/image/diagram/node_user_icon.png" height="20px" width="20px" />
        <image id="crolNode" href="@/assets/image/diagram/node_composite_role_icon.png" height="20px" width="20px" />
        <image id="srolNode" href="@/assets/image/diagram/node_single_role_icon.png" height="20px" width="20px" />
        <image id="cprfNode" href="@/assets/image/diagram/node_composite_profile_icon.png" height="20px" width="20px" />
        <image id="sprfNode" href="@/assets/image/diagram/node_single_profile_icon.png" height="20px" width="20px" />
        <image id="tcodNode" href="@/assets/image/diagram/node_tcode_bundle_icon.png" height="20px" width="20px" />
        <image id="checkImg" href="@/assets/image/diagram/check_icon.png" height="14px" width="13px" />
      </defs>
      <!-- 데이터가 변하면 변해야 하는 것은 computed 에... Redrawn 될 때 변해야 하는 것은 method 에... -->
      <!-- 연결선. 이게 먼저 그려져야 사각형 뒤로 숨는다. -->
      <!-- eslint-disable-next-line prettier/prettier -->
      <path v-for="(item, index) in pathList"
        :key="getKey('LN', index)"
        :d="item.lineD"
        :stroke="item.stroke"
        :stroke-width="item.lineW"
        stroke-linecap="BUTT" stroke-linejoin="MITER" stroke-miterlimit="4" fill="rgb(0, 0, 0)"
        style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);" />
      <!-- Main Rectangle -->
      <!-- eslint-disable-next-line prettier/prettier -->
      <rect v-for="(item, index) in rectList"
        :key="getKey('MR', index)"
        :x="item.rectX"
        :y="item.rectY"
        :width="rectW"
        :height="rectH"
        :fill="rectFill"
        :stroke="item.stroke" :stroke-width="item.lineW" transform="matrix( 1, 0, 0, 1, 0, 0)"
        style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);" />
      <!-- Main Image -->
      <!-- eslint-disable-next-line prettier/prettier -->
      <use v-for="(item, index) in rectList"
        :key="getKey('MI', index)"
        :xlink:href="item.nodeLink"
        :x="item.rectX + 5"
        :y="item.rectY + 5"
        stroke="none" fill="none" style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);"
        v-on:click="openDetail(item)" />
      <!-- Check Rectangle -->
      <!-- eslint-disable-next-line prettier/prettier -->
      <rect v-for="(item, index) in rectList"
        :key="getKey('CR', index)"
        :x="item.rectX + 177"
        :y="item.rectY + 7"
        width="15"
        height="15"
        stroke="#888888" stroke-width="1" fill="url(#x-auto-147)" transform="matrix( 1, 0, 0, 1, 0, 0)"
        style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);"
        v-on:click="rectChecked(item, index)" />
      <!-- Main Text -->
      <!-- eslint-disable-next-line prettier/prettier -->
      <text v-for="(item, index) in rectList"
        :key="getKey('MT', index)"
        :x="item.textX"
        :y="item.textY"
        style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0); font-size: 12px; font-weight: bold;"
        :style="mainTextFill(item)"
        :text-anchor="item.textAnchor"
        font-family="malgun" stroke="none"
        v-on:mouseover="textOver(item, index)" v-on:mouseout="textOut(item, index)">
        <tspan :x="item.textX" dy="12">{{ item.mainText }}</tspan>
      </text>
      <!-- Sub Text -->
      <!-- eslint-disable-next-line prettier/prettier -->
      <text v-for="(item, index) in srchData.srolList"
        :key="getKey('ST', index)"
        :x="item.subTextX"
        :y="item.subTextY"
        style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0); font-size: 12px; font-weight: bold;"
        font-family="malgun" text-anchor="middle" stroke="none"
        fill="rgb(0, 0, 0)">
        <tspan :x="item.subTextX" dy="12">{{ item.subText }}</tspan>
      </text>
      <!-- Check Image -->
      <!-- eslint-disable-next-line prettier/prettier -->
      <use v-for="(item, index) in checkList" :key="getKey('CI', index)"
        xlink:href="#checkImg" :x="checkX(item, index)" :y="checkY(item, index)"
        stroke="none" fill="none" style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);"
        v-on:click="rectChecked(item, index)" />
      <!-- Tcode Rectangle -->
      <!-- eslint-disable-next-line prettier/prettier -->
      <rect v-for="(item, index) in tcodList"
        :key="getKey('TR', index)"
        :x="item.rectX"
        :y="item.rectY"
        width="140"
        :height="rectH"
        :stroke="item.stroke" :stroke-width="item.lineW" fill="none" transform="matrix( 1, 0, 0, 1, 0, 0)"
        style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);" />
      <!-- Tcode Text -->
      <!-- eslint-disable-next-line prettier/prettier -->
      <text v-for="(item, index) in tcodList"
        :key="getKey('TT', index)"
        :x="item.textX"
        :y="item.textY"
        font-family="malgun" text-anchor="middle" stroke="none" fill="rgb(0, 0, 0)"
        style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0); font-size: 12px; font-weight: bold;">
        <tspan :x="item.textX" dy="12">Tcode: {{ item.tcodeCnt }}</tspan>
      </text>
      <!-- Tcode Image -->
      <!-- eslint-disable-next-line prettier/prettier -->
      <use v-for="(item, index) in tcodList"
        :key="getKey('TI', index)"
        :xlink:href="item.nodeLink"
        :x="item.rectX + 117"
        :y="item.rectY + 5"
        height="16px"
        width="16px"
        stroke="none" fill="none" style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);" />
    </svg>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import { comma } from '@/utils/formatter';
export default {
  props: {
    params: {
      type: Object,
    },
    srchData: {
      type: Object,
    },
    diagramHeight: {
      type: Number,
    },
  },
  data() {
    return {
      PKEY: 'a',
      leftX: 50,
      topY: 50,
      rectW: 200,
      rectH: 30,
      gapY: 40,
      checkList: [],
      tcodList: [],
      tcopList: [],
      rectList: [],
      pathList: [],
      userLen: 0,
      crolLen: 0,
      srolLen: 0,
      cprfLen: 0,
      sprfLen: 0,
      roleGapLen: 0,
      svgHeight: 0,
      mainTextFillRed: 'fill: rgb(255, 0, 0);',
      mainTextFillYellow: 'fill: rgb(255, 165, 0);',
      mainTextFillBlue: 'fill: rgb(0, 0, 255);',
      textAchorDefault: 'middle',
      textAchorOver: 'left',
      lineStrokeChecked: 'rgb(200, 0, 200)',
      lineStrokeDefault: 'rgb(160, 160, 160)',
      lineWidthChecked: 2,
      lineWidthDefault: 1,
    };
  },
  computed: {
    rectFill() {
      return this.$vuetify.theme.isDark ? '#000000' : '#FFFFFF';
    },
    forceHeight() {
      return `height: ${this.diagramHeight}px`;
    },
  },
  watch: {
    srchData() {
      const vm = this;

      this.checkList = [];
      this.tcodList = [];
      this.tcopList = [];

      this.userLen = isEmpty(this.srchData.userList) ? 0 : this.srchData.userList.length;
      this.crolLen = isEmpty(this.srchData.crolList) ? 0 : this.srchData.crolList.length;
      this.srolLen = isEmpty(this.srchData.srolList) ? 0 : this.srchData.srolList.length;
      this.cprfLen = isEmpty(this.srchData.cprfList) ? 0 : this.srchData.cprfList.length;
      this.sprfLen = isEmpty(this.srchData.sprfList) ? 0 : this.srchData.sprfList.length;

      this.roleGapLen = this.crolLen > this.srolLen ? this.crolLen : this.srolLen;

      let uSize = this.userLen;
      let cSize = this.crolLen + this.cprfLen;
      let sSize = this.srolLen + this.sprfLen;
      let biggist = uSize < cSize ? (cSize < sSize ? sSize : cSize) : uSize < sSize ? sSize : uSize;
      this.svgHeight = this.topY + this.gapY * biggist + 100;

      // 노드 요소 목록에 대해 루프를 돌면서 SVG 렌더링에 필요한 값들을 초기화한다.
      if (this.userLen > 0) {
        this.srchData.userList.forEach((elm, idx) => {
          elm.myIdx = idx;
          // 처음 X,Y 위치에 0.5를 더해주는 이유는?
          // Answer: 그냥 선(사각형의 선 포함)을 그으면 pixel 사이에 선이 위치하게 되면서 선이 번져서 두껍게 그려지게 되는 현상이 발생할 수 있다.
          //         0.5를 더해주면 그 현상이 없어진다.2020.12.22.KWShin.
          elm.rectX = vm.leftX + 0.5;
          elm.rectY = vm.topY + 0.5 + vm.gapY * idx;
          elm.stroke = vm.lineStrokeDefault;
          elm.lineW = vm.lineWidthDefault;
          elm.textX = elm.rectX + vm.rectW / 2;
          elm.textY = elm.rectY + 7;
          elm.textAnchor = vm.textAchorDefault;
          elm.name = elm.bname;
          elm.mainText = vm.getEllipsisText(elm.name);
          elm.nodeLink = '#userNode';
        });
      }
      if (this.crolLen > 0) {
        this.srchData.crolList.forEach((elm, idx) => {
          elm.myIdx = idx;
          elm.rectX = vm.leftX + 400.5;
          elm.rectY = vm.topY + 0.5 + vm.gapY * idx;
          elm.stroke = vm.lineStrokeDefault;
          elm.lineW = vm.lineWidthDefault;
          elm.textX = elm.rectX + vm.rectW / 2;
          elm.textY = elm.rectY + 7;
          elm.textAnchor = vm.textAchorDefault;
          elm.name = elm.agrName;
          elm.mainText = vm.getEllipsisText(elm.name);
          elm.nodeLink = '#crolNode';
        });
      }
      if (this.srolLen > 0) {
        this.srchData.srolList.forEach((elm, idx) => {
          elm.myIdx = idx;
          elm.rectX = vm.leftX + 800.5;
          elm.rectY = vm.topY + 0.5 + vm.gapY * idx;
          elm.stroke = vm.lineStrokeDefault;
          elm.lineW = vm.lineWidthDefault;
          elm.textX = elm.rectX + vm.rectW / 2;
          elm.textY = elm.rectY + 1;
          elm.textAnchor = vm.textAchorDefault;
          elm.name = elm.agrName;
          elm.mainText = vm.getEllipsisText(elm.name);
          elm.subTextX = elm.rectX + vm.rectW / 2;
          elm.subTextY = elm.rectY + 16;
          elm.subText = elm.profile;
          elm.nodeLink = '#srolNode';
          // Single role에 profile로 연결되어 할당된 Tcode를 보여주기 위한 노드 요소를 생성한다.
          if (elm.tcodeCnt > 0) {
            const tcod = {
              agrName: elm.agrName,
              profn: elm.profile,
              type: 'R',
              tcodeCnt: vm.getTcodeCntString(elm.tcodeCnt),
              myIdx: idx,
              rectX: elm.rectX + 300,
              rectY: elm.rectY,
              textX: elm.rectX + 300 + 70,
              textY: elm.rectY + 7,
              stroke: vm.lineStrokeDefault,
              lineW: vm.lineWidthDefault,
              nodeLink: '#tcodNode',
            };
            vm.tcodList.push(tcod);
            // Single role과 위에서 생성한 Tcode 노드 요소와의 연결 선을 생성한다.
            const tcodPath = {
              stroke: vm.lineStrokeDefault,
              lineW: vm.lineWidthDefault,
              frItem: elm,
              toItem: tcod,
              lineD: `M${elm.rectX + 200} ${elm.rectY + vm.rectH / 2} L${elm.rectX + 300} ${elm.rectY + vm.rectH / 2}`,
            };
            vm.tcopList.push(tcodPath);
          }
        });
      }
      if (this.cprfLen > 0) {
        this.srchData.cprfList.forEach((elm, idx) => {
          elm.myIdx = idx;
          elm.rectX = vm.leftX + 400.5;
          elm.rectY = vm.topY + 0.5 + vm.gapY * (this.roleGapLen + idx);
          elm.stroke = vm.lineStrokeDefault;
          elm.lineW = vm.lineWidthDefault;
          elm.textX = elm.rectX + vm.rectW / 2;
          elm.textY = elm.rectY + 7;
          elm.textAnchor = vm.textAchorDefault;
          elm.name = elm.profn;
          elm.mainText = vm.getEllipsisText(elm.name);
          elm.nodeLink = '#cprfNode';
        });
      }
      if (this.sprfLen > 0) {
        this.srchData.sprfList.forEach((elm, idx) => {
          elm.myIdx = idx;
          elm.rectX = vm.leftX + 800.5;
          elm.rectY = vm.topY + 0.5 + vm.gapY * (this.roleGapLen + idx);
          elm.stroke = vm.lineStrokeDefault;
          elm.lineW = vm.lineWidthDefault;
          elm.textX = elm.rectX + vm.rectW / 2;
          elm.textY = elm.rectY + 7;
          elm.textAnchor = vm.textAchorDefault;
          elm.name = elm.profn;
          elm.mainText = vm.getEllipsisText(elm.name);
          elm.nodeLink = '#sprfNode';
          // Single profile에 할당된 Tcode를 보여주기 위한 노드 요소를 생성한다.
          if (elm.tcodeCnt > 0) {
            const tcod = {
              profn: elm.profn,
              type: 'P',
              tcodeCnt: vm.getTcodeCntString(elm.tcodeCnt),
              myIdx: idx,
              rectX: elm.rectX + 300,
              rectY: elm.rectY,
              textX: elm.rectX + 300 + 70,
              textY: elm.rectY + 7,
              stroke: vm.lineStrokeDefault,
              lineW: vm.lineWidthDefault,
              nodeLink: '#tcodNode',
            };
            vm.tcodList.push(tcod);
            // Single profile과 위에서 생성한 Tcode 노드 요소와의 연결 선을 생성한다.
            const tcodPath = {
              stroke: vm.lineStrokeDefault,
              lineW: vm.lineWidthDefault,
              frItem: elm,
              toItem: tcod,
              lineD: `M${elm.rectX + 200} ${elm.rectY + vm.rectH / 2} L${elm.rectX + 300} ${elm.rectY + vm.rectH / 2}`,
            };
            vm.tcopList.push(tcodPath);
          }
        });
      }
      // 모든 노드 요소 목록을 하나의 배열 rectList로 묶는다.
      this.rectList = [].concat(this.srchData.userList, this.srchData.crolList, this.srchData.srolList, this.srchData.cprfList, this.srchData.sprfList);

      // 관계 요소 목록에 대해 루프를 돌면서 SVG 렌더링에 필요한 값들을 초기화한다.
      if (this.srchData.cr2uList.length > 0) {
        this.srchData.cr2uList.forEach(elm => {
          elm.stroke = vm.lineStrokeDefault;
          elm.lineW = vm.lineWidthDefault;
          let moveData = this.getMovePoint(this.srchData.userList, elm);
          elm.frItem = moveData.item;
          let lineData = this.getLinePoint(this.srchData.crolList, elm);
          elm.toItem = lineData.item;
          elm.lineD = `${moveData.point} ${lineData.point}`;
        });
      }
      if (this.srchData.sr2uList.length > 0) {
        this.srchData.sr2uList.forEach(elm => {
          elm.stroke = vm.lineStrokeDefault;
          elm.lineW = vm.lineWidthDefault;
          let moveData = this.getMovePoint(this.srchData.userList, elm);
          elm.frItem = moveData.item;
          let lineData = this.getLinePoint(this.srchData.srolList, elm);
          elm.toItem = lineData.item;
          elm.lineD = `${moveData.point} ${lineData.point}`;
        });
      }
      if (this.srchData.cp2uList.length > 0) {
        this.srchData.cp2uList.forEach(elm => {
          elm.stroke = vm.lineStrokeDefault;
          elm.lineW = vm.lineWidthDefault;
          let moveData = this.getMovePoint(this.srchData.userList, elm);
          elm.frItem = moveData.item;
          let lineData = this.getLinePoint(this.srchData.cprfList, elm);
          elm.toItem = lineData.item;
          elm.lineD = `${moveData.point} ${lineData.point}`;
        });
      }
      if (this.srchData.sp2uList.length > 0) {
        this.srchData.sp2uList.forEach(elm => {
          elm.stroke = vm.lineStrokeDefault;
          elm.lineW = vm.lineWidthDefault;
          let moveData = this.getMovePoint(this.srchData.userList, elm);
          elm.frItem = moveData.item;
          let lineData = this.getLinePoint(this.srchData.sprfList, elm);
          elm.toItem = lineData.item;
          elm.lineD = `${moveData.point} ${lineData.point}`;
        });
      }
      if (this.srchData.srcrList.length > 0) {
        this.srchData.srcrList.forEach(elm => {
          elm.stroke = vm.lineStrokeDefault;
          elm.lineW = vm.lineWidthDefault;
          let moveData = this.getMovePoint(this.srchData.crolList, elm);
          elm.frItem = moveData.item;
          let lineData = this.getLinePoint(this.srchData.srolList, elm);
          elm.toItem = lineData.item;
          elm.lineD = `${moveData.point} ${lineData.point}`;
        });
      }
      if (this.srchData.spcpList.length > 0) {
        this.srchData.spcpList.forEach(elm => {
          elm.stroke = vm.lineStrokeDefault;
          elm.lineW = vm.lineWidthDefault;
          let moveData = this.getMovePoint(this.srchData.cprfList, elm);
          elm.frItem = moveData.item;
          let lineData = this.getLinePoint(this.srchData.sprfList, elm);
          elm.toItem = lineData.item;
          elm.lineD = `${moveData.point} ${lineData.point}`;
        });
      }
      // 모든 노드 요소 목록을 하나의 배열 pathList로 묶는다.
      this.pathList = [].concat(this.srchData.cr2uList, this.srchData.sr2uList, this.srchData.cp2uList, this.srchData.sp2uList, this.srchData.srcrList, this.srchData.spcpList, this.tcopList);
    },
  },
  methods: {
    // 모든 노드와 관계 요소가 key값을 가지고 있기는 하나,
    // 요소들의 목록이 SVG element들에서 반복적으로 사용되기 때문에 (중복된다고 뭐라뭐라 한다...)
    // SVG element 유형별로 따로 key 값을 생성한다.
    getKey(type, index) {
      return `${type}${index}`;
    },
    // 연결 요소의 좌측에 맵핑되는 노드 요소를 찾아 연결 요소의 시작점을 구한다.
    getMovePoint(rectList, relation) {
      let rtnData = {};
      for (let rect of rectList) {
        if (rect.name == relation.leftName) {
          rtnData.point = `M${rect.rectX + this.rectW} ${rect.rectY + this.rectH / 2}`;
          rtnData.item = rect;
          break;
        }
      }
      return rtnData;
    },
    // 연결 요소의 우측에 맵핑되는 노드 요소를 찾아 연결 요소의 종점을 구한다.
    getLinePoint(rectList, relation) {
      let rtnData = {};
      for (let rect of rectList) {
        if (rect.name == relation.rightName) {
          rtnData.point = `L${rect.rectX} ${rect.rectY + this.rectH / 2}`;
          rtnData.item = rect;
          break;
        }
      }
      return rtnData;
    },
    // 노드 요소의 이름이 너무 길 경우 노드 영역을 넘치게 되므로 적절히 잘라준다.
    getEllipsisText(text) {
      if (text.length > 18) return ''.concat(`${text.substring(0, 17)}...`);
      else return ''.concat(text);
    },
    // 노드 요소의 이름의 색상을 결정한다.
    mainTextFill(item) {
      if (item.modelType == 'CROL' || item.modelType == 'SROL') {
        if (item.statusColor == 'R') return this.mainTextFillRed;
        else if (item.statusColor == 'Y') return this.mainTextFillYellow;
        else return this.mainTextFillBlue;
      }
      return this.$vuetify.theme.isDark ? 'fill: #FFFFFF;' : 'fill: #000000;';
    },
    getTcodeCntString(cnt) {
      return cnt == 999999999 ? '*' : comma(cnt);
    },
    textOver(item, index) {
      if (item.mainText == item.name) return;
      item.mainText = item.name;
      item.textX = item.rectX + 30;
      item.textAnchor = this.textAchorOver;
      // 배열이나 객체를 변경할 때 다음과 같이 하면 react가 일어난다. Vue.$delete() 참조.
      this.$set(this.rectList, index, item);
    },
    textOut(item, index) {
      if (item.textAnchor == this.textAchorDefault) return;
      item.mainText = this.getEllipsisText(item.name);
      item.textX = item.rectX + this.rectW / 2;
      item.textAnchor = this.textAchorDefault;
      this.$set(this.rectList, index, item);
    },
    // 노드 요소 선택 시 보여지는 Check 이미지를 렌더링한 위치를 구한다.
    checkX(item) {
      switch (item.modelType) {
        case 'USER':
          return this.leftX + 179.5;
        case 'CROL':
        case 'CPRF':
          return this.leftX + 579.5;
        case 'SROL':
        case 'SPRF':
          return this.leftX + 979.5;
      }
    },
    checkY(item) {
      switch (item.modelType) {
        case 'USER':
        case 'CROL':
        case 'SROL':
          return this.topY + 8.5 + this.gapY * item.myIdx;
        case 'CPRF':
        case 'SPRF':
          return this.topY + 8.5 + this.gapY * (this.roleGapLen + item.myIdx);
      }
    },
    // 노드 요소의 check box나 check image가 클릭되었을 때의 동작...
    rectChecked(item) {
      let checkLen = this.checkList.length;
      // 이미 하나 이상의 노드가 선택되어 있는 경우, 새롭게 선택된 노드의 중복 여부를 판단하여
      // 선택 상태에서 다시 선택되면 선택을 해제한다.
      if (checkLen > 0) {
        for (let i = 0; i < checkLen; i++) {
          let checkItem = this.checkList[i];
          if (checkItem.modelType == item.modelType && checkItem.name == item.name) {
            // 선택이 해제되면 선택된 목록에서 제거하고
            this.checkList.splice(i, 1);
            // 노드 사각형의 외곽선과 연관된 연결선의 두께와 색상을 원복한다.
            this.rerenderCheckedItem(item, false);
            // 선택되어 있는 노드 사각형의 외곽선과 연관된 연결선의 두께와 색상을 선택 상태로 바꾸어 준다.
            this.checkList.forEach(elm => this.rerenderCheckedItem(elm, true));
            return;
          }
        }
      }
      // 두개가 초과되어 선택되면 선택된 목록 상의 가장 처음 노드를 선택해제한다. 항상 최대 2개만 선택된다.
      if (this.checkList.length == 2) {
        // 첫번째 노드를 목록에서 제거하고
        let removed = this.checkList.splice(0, 1);
        // 노드 사각형의 외곽선과 연관된 연결선의 두께와 색상을 원복한다.
        this.rerenderCheckedItem(removed[0], false);
      }
      // 선택된 노드를 선택 목록에 추가하고
      this.checkList.push(item);
      // 선택되어 있는 노드 사각형의 외곽선과 연관된 연결선의 두께와 색상을 선택 상태로 바꾸어 준다.
      this.checkList.forEach(elm => this.rerenderCheckedItem(elm, true));
    },
    rerenderCheckedItem(item, checked) {
      this.setCheckedItemStroke(item, checked);
      if ('USER' == item.modelType) {
        for (let cr2u of this.srchData.cr2uList) {
          if (cr2u.leftName == item.name) {
            this.setCheckedItemStroke(cr2u, checked);
            this.setCheckedItemStroke(cr2u.toItem, checked);
            this.setRelatedSrolListDeep(cr2u.toItem, checked);
          }
        }
        for (let sr2u of this.srchData.sr2uList) {
          if (sr2u.leftName == item.name) {
            this.setCheckedItemStroke(sr2u, checked);
            this.setCheckedItemStroke(sr2u.toItem, checked);
            this.setRelatedTcodListDeep(sr2u.toItem, checked);
          }
        }
        for (let cp2u of this.srchData.cp2uList) {
          if (cp2u.leftName == item.name) {
            this.setCheckedItemStroke(cp2u, checked);
            this.setCheckedItemStroke(cp2u.toItem, checked);
            this.setRelatedSprfListDeep(cp2u.toItem, checked);
          }
        }
        for (let sp2u of this.srchData.sp2uList) {
          if (sp2u.leftName == item.name) {
            this.setCheckedItemStroke(sp2u, checked);
            this.setCheckedItemStroke(sp2u.toItem, checked);
            this.setRelatedTcodListDeep(sp2u.toItem, checked);
          }
        }
      } else if ('CROL' == item.modelType) {
        this.setCheckedItemStroke(item, checked);
        this.setRelatedUserListDeep(item, this.srchData.cr2uList, checked);
        this.setRelatedSrolListDeep(item, checked);
      } else if ('SROL' == item.modelType) {
        this.setCheckedItemStroke(item, checked);
        this.setRelatedUserListDeep(item, this.srchData.sr2uList, checked);
        for (let srcr of this.srchData.srcrList) {
          if (srcr.rightName == item.name) {
            this.setCheckedItemStroke(srcr, checked);
            this.setCheckedItemStroke(srcr.frItem, checked);
            for (let cr2u of this.srchData.cr2uList) {
              if (cr2u.rightName == srcr.frItem.name) {
                this.setCheckedItemStroke(cr2u, checked);
                this.setCheckedItemStroke(cr2u.frItem, checked);
              }
            }
          }
        }
        this.setRelatedTcodListDeep(item, checked);
      } else if ('CPRF' == item.modelType) {
        this.setCheckedItemStroke(item, checked);
        this.setRelatedUserListDeep(item, this.srchData.cp2uList, checked);
        this.setRelatedSprfListDeep(item, checked);
      } else if ('SPRF' == item.modelType) {
        this.setCheckedItemStroke(item, checked);
        this.setRelatedUserListDeep(item, this.srchData.sp2uList, checked);
        for (let spcp of this.srchData.spcpList) {
          if (spcp.rightName == item.name) {
            this.setCheckedItemStroke(spcp, checked);
            this.setCheckedItemStroke(spcp.frItem, checked);
            for (let cp2u of this.srchData.cp2uList) {
              if (cp2u.rightName == spcp.frItem.name) {
                this.setCheckedItemStroke(cp2u, checked);
                this.setCheckedItemStroke(cp2u.frItem, checked);
              }
            }
          }
        }
        this.setRelatedTcodListDeep(item, checked);
      }
    },
    setCheckedItemStroke(item, checked) {
      item.stroke = checked ? this.lineStrokeChecked : this.lineStrokeDefault;
      item.lineW = checked ? this.lineWidthChecked : this.lineWidthDefault;
    },
    setRelatedUserListDeep(item, relationList, checked) {
      for (var relation of relationList) {
        if (relation.rightName == item.name) {
          this.setCheckedItemStroke(relation, checked); // 사용자-CRole/SRole/CPrfl/SPrfl 체크.
          this.setCheckedItemStroke(relation.frItem, checked); // 사용자 체크.
        }
      }
    },
    setRelatedSrolListDeep(item, checked) {
      for (var srcr of this.srchData.srcrList) {
        if (srcr.leftName == item.name) {
          this.setCheckedItemStroke(srcr, checked);
          this.setCheckedItemStroke(srcr.toItem, checked);
          this.setRelatedTcodListDeep(srcr.toItem, checked);
        }
      }
    },
    setRelatedSprfListDeep(item, checked) {
      for (var spcp of this.srchData.spcpList) {
        if (spcp.leftName == item.name) {
          this.setCheckedItemStroke(spcp, checked);
          this.setCheckedItemStroke(spcp.toItem, checked);
          this.setRelatedTcodListDeep(spcp.toItem, checked);
        }
      }
    },
    setRelatedTcodListDeep(item, checked) {
      for (var tcop of this.tcopList) {
        // eslint-disable-next-line prettier/prettier
        if ((tcop.frItem.modelType == 'SROL' && tcop.toItem.agrName == item.name)
         || (tcop.frItem.modelType == 'SPRF' && tcop.toItem.profn == item.name)) {
          this.setCheckedItemStroke(tcop, checked);
          this.setCheckedItemStroke(tcop.toItem, checked);
        }
      }
    },
    openDetail(item) {
      let url, params, options;
      params = {
        ymd: this.params.svrYmdhms,
        sstm: this.params.sstmId,
        mand: this.params.mandt,
        entt: item.modelType,
        name: item.name,
      };
      // console.log('in SearchDiagram.vue, in openDetail(), item=', item);
      url = '/views/extra/auth/rtrck-search-detail';
      options = 'width=1600, height=846';
      window.open(`${url}?${new URLSearchParams(params).toString()}`, '_blank', options);
    },
    onResize() {
      this.height = window.innerHeight - 204;
    },
  },
};
</script>

<style scoped>
.diagram-container {
  overflow: auto;
  position: relative;
  zoom: 1;
  left: 0px;
  top: 0px;
}
</style>
